import type { Config } from "dompurify";

/** DOMPurify config object (same allowlist for server + client). */
export const BLOG_SANITIZE_CONFIG: Config = {
  ALLOWED_TAGS: [
    "p",
    "h2",
    "h3",
    "h4",
    "ul",
    "ol",
    "li",
    "blockquote",
    "code",
    "pre",
    "a",
    "img",
    "figure",
    "figcaption",
    "hr",
    "br",
    "strong",
    "em",
    "u",
    "s",
    "span",
    "mark",
    "iframe",
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
  ],
  ALLOWED_ATTR: [
    "href",
    "src",
    "alt",
    "title",
    "class",
    "target",
    "rel",
    "width",
    "height",
    "frameborder",
    "allow",
    "allowfullscreen",
  ],
  ALLOW_DATA_ATTR: false,
  FORBID_ATTR: ["style"],
};

export const IFRAME_ALLOWED =
  /^https:\/\/(www\.)?(youtube\.com\/embed\/|youtube-nocookie\.com\/embed\/)/i;
